import type { ICellRendererParams } from 'ag-grid-community';
import { memo } from 'react';
import type { LPSettlementReportBlotterRow } from '../UnsettledTransactions/blotter/lpSettlementReportRow';
import { LPTradeStatusRenderer } from '../components/LPTradeStatusRenderer';

export const TradeStatusCell = memo(function CombinedStatusCell(
  props: ICellRendererParams<LPSettlementReportBlotterRow>
) {
  const { context, data, node } = props;

  if (!context.current.theme) {
    return null;
  }

  const status =
    node.group && node.field === 'EventID' ? node?.allLeafChildren?.[0]?.data?.SettleStatus : data?.SettleStatus;

  if (!status) {
    return null;
  }

  return <LPTradeStatusRenderer theme={context.current.theme} status={status} />;
});
